type PrevNextPaginatorLabelProps = {
  current: number;
  pagesCount: number;
};

const PrevNextPaginatorLabel = ({
  current,
  pagesCount,
}: PrevNextPaginatorLabelProps) => (
  <span data-test-id="prev-next-paginator-label">
    {current + 1} out of {pagesCount}
  </span>
);

export default PrevNextPaginatorLabel;
